<div class="customer-view-container">
  <div class="customer-view-sections">
    <div class="meeting-form">
      <h1>Schedule a Meeting</h1>
      <h3>Meeting Type</h3>
      <div class="cards">
        @for (meetingType of meetingTypes$ | async; track meetingType.id) {
          <div class="meeting-type-card card" (click)="radio.click()">
            <div class="radio-holder">
              <input
                #radio
                name="meeting-type-radio"
                type="radio"
                (change)="updateMeetingTypeValue(meetingType)" />
            </div>
            <div class="details">
              <h3>{{ meetingType.label }}</h3>
              <p>{{ meetingType.description }}</p>
              <p>${{ meetingType.price }}</p>
              <p>{{ meetingType.durationInMinutes }} Minutes</p>
            </div>
          </div>
        }
      </div>
      <br />
      <!-- <mat-form-field appearance="outline">
        <mat-label>Date</mat-label>
        <input
          matInput
          [matDatepicker]="datepicker"
          [formControl]="dateFormControl" />
        <mat-datepicker #datepicker />
        <mat-datepicker-toggle [for]="datepicker" matSuffix />
      </mat-form-field> -->
      <mat-form-field appearance="outline">
        <mat-label>Date</mat-label>
        <mat-select [formControl]="dateFormControl">
          @for (
            option of mapMeetingAvailabilitiesToWeekdayOptions(
              (meetingAvailabilities$ | async) ?? []
            );
            track $index
          ) {
            <mat-option [value]="option.value">{{ option.label }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>Time</mat-label>
        <mat-select [formControl]="timeFormControl">
          @for (
            option of getTimeOptions(
              dateFormControl.value,
              (meetingAvailabilities$ | async) ?? [],
              (scheduledMeetings$ | async) ?? []
            );
            track $index
          ) {
            <mat-option [value]="option.value">{{ option.label }}</mat-option>
          }
        </mat-select>
      </mat-form-field>

      <button
        mat-flat-button
        color="primary"
        [disabled]="!isValid()"
        (click)="submit()">
        Submit Request
      </button>
      <a mat-flat-button href="/"> Cancel </a>
    </div>
  </div>
</div>
